export default __webpack_public_path__ + "static/media/wdoclogo7.9a8cb274.png";